export const isDateString = value => {
  if (value instanceof Date) return true;
  if (typeof value !== 'string' || !value.trim()) return false;

  const isoDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?$/;
  const ymdPattern = /^\d{4}-\d{2}-\d{2}$/;

  if (isoDatePattern.test(value) || ymdPattern.test(value)) return true;

  const versionPattern = /^\d+(?:\.\d+)+(?:\s*\([^)]*\))?$/;
  if (versionPattern.test(value.trim())) return false;

  if (/[a-z]/i.test(value) && /\d/.test(value)) return false;
  if (!/[-/ ]/.test(value)) return false;

  const date = new Date(value);
  return Number.isFinite(date.getTime());
};

export const getDateSelectedDayAgo = day => {
  const pastDay = new Date().getDate() - day + 1;
  const pastDateMiliseconds = new Date().setDate(pastDay);

  return new Date(pastDateMiliseconds);
};

export const getUTCStartOfDayISOString = date => {
  if (!date) return null;

  const value = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(value.getTime())) return null;

  return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate())).toISOString();
};

export const getUTCEndOfDayISOString = date => {
  if (!date) return null;

  const value = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(value.getTime())) return null;

  return new Date(
    Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), 23, 59, 59, 999),
  ).toISOString();
};
